import React, { Fragment } from 'react';
import AbstractComponent from '../../AbstractComponent';
import Preload from '../preload/Preload';
import Sucesso from '../alert/Sucesso';
import ModalAlerta from '../modal/ModalAlerta';

class ActionButton extends AbstractComponent {       
    showComponent() {
        if(!this.props.visible)
            return ;

        return (
            <Fragment>
                <Sucesso 
                    exibir={this.props.textoSucesso !== ''} 
                    texto={this.props.textoSucesso}
                    timeOut={5}
                    onTimeOut={() => this.props.onTimeOut()}
                />

                <Preload show={this.props.preload} />

                <ModalAlerta
                    show={this.props.erro.code !== 0}
                    texto={this.props.erro.message}

                    fechar={() => this.props.onClose()}
                />

                {this.props.children}             
            </Fragment>
        );
    }

    render() {
        return (  
            <Fragment>                
                {this.showComponent()}
            </Fragment>          
        )
    }
}

ActionButton.defaultProps = {
    visible: true
}

export default ActionButton;